<script>
import baseMixin from '@/mixins/baseMixin'
import LocationRestriction from '@/models/locationRestriction/locationRestriction'

export default {
  name: 'LocationRestrictionRemover',
  mixins: [baseMixin],
  model: {
    event: 'input',
    prop: 'value',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    restriction: {
      type: LocationRestriction,
      default: () => null,
    },
    loading: Boolean,
  },
  computed: {
    isShowing: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    cardTitle() {
      return this.restriction?.clientName ?? ''
    },
    cardSubtitle() {
      return this.restriction?.locationName ?? ''
    },
  },
  methods: {
    handleConfirmClick() {
      this.$emit('confirm')
    },
    handleCancelClick() {
      this.$emit('cancel')
    },
  },
}
</script>

<template>
  <v-card>
    <v-card-title> {{ cardTitle }} </v-card-title>
    <v-card-subtitle> {{ cardSubtitle }}</v-card-subtitle>

    <v-card-text>
      {{ $t('locationRestrictions.remove.bodyMessage') }}
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn text @click="handleCancelClick">
        {{ $t('locationRestrictions.remove.cancelBtn') }}
      </v-btn>
      <v-spacer> </v-spacer>
      <v-btn color="primary" text @click="handleConfirmClick">
        {{ $t('locationRestrictions.remove.confirmBtn') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
